import { render, staticRenderFns } from "./UnitsSummary.vue?vue&type=template&id=7bcf98f5&"
import script from "./UnitsSummary.vue?vue&type=script&lang=js&"
export * from "./UnitsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports